const ZonalColumns = [
  {
    name: "ZONAL RANK",
    value: "rank",
    show: true,
    isBold: true,
  },
  {
    name: "OVERALL RANK",
    value: "overall-rank",
    show: true,
    isBold: true,
  },
  {
    name: "INSTITUTE",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "TOTAL SCORE",
    value: "total-score",
    show: true,
    isBold: true,
  },
  {
    name: "DISTANCE TO FRONTIER",
    value: "distance-to-frontier",
    show: true,
    isBold: true,
  },
];

export default ZonalColumns;
